import { Button } from '@apollo/orbit';
import { Observatory } from '@apollo/space-kit/illustrations/Observatory';
import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useRouteParams } from 'src/hooks/useRouteParams';
import { catchAllRouteConfig } from 'src/lib/routeConfig/catchAllRoute';

import {
  API_SCHEMA_ID,
  SUPERGRAPH_SCHEMA_ID,
} from '../../documentationPage/sdlPage/sdlDisplay/SDLDisplay';
import { proposalChangesRouteConfig } from '../../routes';

export const ResetFiltersEmptyChangesState = ({
  proposalIsImplemented,
}: {
  proposalIsImplemented: boolean;
}) => {
  const { selectedSchema } = useRouteParams(
    proposalChangesRouteConfig,
    catchAllRouteConfig,
  );
  const selectedSchemaDisplayName = useMemo(() => {
    switch (selectedSchema) {
      case API_SCHEMA_ID:
        return 'on the Api Schema';
      case SUPERGRAPH_SCHEMA_ID:
        return 'on the Supergraph Schema';
      case undefined:
        return 'on this schema';
      default:
        return `on subgraph ${selectedSchema}`;
    }
  }, [selectedSchema]);
  const location = useLocation();
  return (
    <div className="my-10 flex size-full flex-col items-center justify-center">
      <Observatory className="mb-3" />
      <h2 className="text-center text-2xl font-semibold">
        All changes {!proposalIsImplemented && `${selectedSchemaDisplayName} `}
        have have been implemented.
      </h2>
      <p className="mb-3 max-w-[65ch] text-center text-base text-secondary">
        {!proposalIsImplemented
          ? 'Try selecting another schema.'
          : 'Try removing filters.'}
      </p>
      <Button
        as={Link}
        to={proposalChangesRouteConfig.locationFrom({
          location,
          fromRouteConfig: proposalChangesRouteConfig,
          patch: {
            includeImplementedChanges: 'true',
          },
        })}
      >
        Reset filters
      </Button>
    </div>
  );
};
